import { render, staticRenderFns } from "./CrossSells.vue?vue&type=template&id=55e6dfbd&scoped=true"
import script from "./CrossSells.vue?vue&type=script&lang=js"
export * from "./CrossSells.vue?vue&type=script&lang=js"
import style0 from "./CrossSells.vue?vue&type=style&index=0&id=55e6dfbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e6dfbd",
  null
  
)

export default component.exports